'use client';

import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { CART_COUPON_DISCOUNT_LABEL } from './cart-coupon/cart-coupon.const';

import { Button } from '@/components/ui/button/button.component';
import { currencyFormatter } from '@/utils/formatters/currency';

interface CartFooterProps {
  total: number;
  discount?: number;
  onProceed: () => void;
}

export function CartFooter({ total, discount = 0, onProceed }: CartFooterProps) {
  return (
    <footer
      className="absolute inset-x-0 bottom-0 z-10 bg-gradient-to-b from-white/0 via-white via-30% to-white px-3 pb-3 pt-8"
      data-testid={DataTestIdEnum.CART_FOOTER}
    >
      <div className="flex items-center gap-2 rounded-xxl border border-gray-300 bg-gray-100 py-2 pl-4 pr-2">
        <div className="flex flex-1 flex-col">
          {discount > 0 && (
            <p
              className="whitespace-nowrap text-sm leading-5 text-gray-700"
              data-testid={DataTestIdEnum.CART_FOOTER_DISCOUNT}
            >
              {CART_COUPON_DISCOUNT_LABEL}
              {' '}
              <span className="font-semibold text-success-600">{`-${currencyFormatter(discount)}`}</span>
            </p>
          )}

          <p
            className="whitespace-nowrap text-lg leading-6 text-gray-800"
            data-testid={DataTestIdEnum.CART_FOOTER_TOTAL}
          >
            Total
            {' '}
            <span className="font-bold">{currencyFormatter(total)}</span>
          </p>
        </div>

        <Button
          className="w-auto shrink-0"
          data-testid={DataTestIdEnum.CART_FOOTER_PROCEED_BUTTON}
          onClick={onProceed}
        >
          Prosseguir
        </Button>
      </div>
    </footer>
  );
}
